import { formatDateTime } from '~/@lib/utils/date.utils'

function DateTimeFormatter(props: { value: string }) {
  return <span>{formatDateTime(props.value)}</span>
}

export { DateTimeFormatter }
